import React from 'react';
import { Modal } from '@trackman/web-shared-components';
import Loader from 'components/loader/Loader';
import { ContentWrapper, IconAndTextRow, IconWrapper, Text } from './styles/LoadingModalStyles';

interface IProps {
  title: string;
  text: string;
  visible: boolean;
}

export const LoadingModal: React.FC<IProps> = ({ title, text, visible }) => {
  return (
    <Modal open={visible} onClose={() => {}} maxWidth='sm' className='loading-modal' title={title}>
      <ContentWrapper>
        <IconAndTextRow>
          <IconWrapper>
            <Loader />
          </IconWrapper>
          <Text>{text}</Text>
        </IconAndTextRow>
      </ContentWrapper>
    </Modal>
  );
};
